export const messages = {
  fr: {
    nav: {
      pilotage: 'Pilotage', gestion: 'Gestion', ecosysteme: 'Écosystème', systeme: 'Système',
      dashboard: 'Tableau de bord', members: 'Membres', finance: 'Finance', rewards: 'Récompenses', content: 'Contenus',
      administrators: 'Administration', marketplace: 'Marketplace', boutique: 'Boutique',
      community: 'Communauté', communication: 'Communication', settings: 'Paramètres',
      configuration: 'Configuration', console: 'Console système',
    },
    common: {
      refresh: 'Actualiser', save: 'Enregistrer', cancel: 'Annuler', confirm: 'Confirmer',
      loading: 'Chargement...', error: 'Erreur', empty: 'Aucune donnée', retry: 'Réessayer',
      search: 'Rechercher', filters: 'Filtres', actions: 'Actions', logout: 'Déconnexion',
      profile: 'Profil', demo: 'Données de démonstration', preparation: 'Préparation',
      close: 'Fermer', edit: 'Modifier', delete: 'Supprimer', archive: 'Archiver',
      active: 'Actif', inactive: 'Inactif', operational: 'Opérationnel', unavailable: 'Non disponible',
      total: 'Total', status: 'Statut', type: 'Type', date: 'Date', all: 'Tous',
      overview: "Vue d'ensemble", details: 'Détails', create: 'Créer', publish: 'Publier',
      realData: 'Données réelles', demoData: 'Données de démonstration',
      noData: 'Aucune donnée disponible', workerUnavailable: 'Service temporairement indisponible',
      comingSoon: 'Bientôt disponible',
    },
    pages: {
      dashboard: { title: "Vue d'ensemble", subtitle: 'Pilotage global de la plateforme DSI Academy.' },
      members: { title: 'Membres', subtitle: 'Analyse et gestion des membres de la plateforme.' },
      finance: { title: 'Finance & Transactions', subtitle: 'Centre financier et suivi des opérations.' },
      rewards: { title: 'Récompenses', subtitle: 'Gestion des codes récompense DSI.' },
      library: { title: 'Contenus', subtitle: 'Pilotage du catalogue pédagogique.' },
      administrators: { title: 'Gestion des Administrateurs', subtitle: "Contrôlez les accès, les rôles et les niveaux d'autorité." },
      marketplace: { title: 'Marketplace DSI', subtitle: "Centre de pilotage de l'économie entre membres." },
      boutique: { title: 'Boutique DSI', subtitle: 'Centre des produits institutionnels DSI.' },
      community: { title: 'Communauté DSI', subtitle: 'Conversations, espaces, appels et activité.' },
      communication: { title: 'Communication & Notifications', subtitle: 'Centre de pilotage des communications.' },
      security: { title: 'Centre de contrôle', subtitle: 'Supervision, maintenance et configuration administrative.' },
      settings: { title: 'Paramètres', subtitle: 'Préférences du portail et observation de l’écosystème.' },
    },
    dashboard: {
      members: 'Membres', payments: 'Paiements', withdrawals: 'Retraits', admins: 'Administrateurs',
      activity: 'Activité', ecosystem: 'Écosystème', memberStatus: 'Statut des membres',
      financial: 'Vue financière',
    },
    members: {
      totalMembers: 'Total membres', active: 'Actifs', pending: 'En attente', inactive: 'Inactifs',
      distribution: 'Répartition', evolution: 'Évolution', list: 'Liste des membres',
    },
    finance: {
      payments: 'Paiements', withdrawals: 'Demandes de retrait', journal: 'Journal financier',
      levels: 'Niveaux DSI', amount: 'Montant', pending: 'En attente', validated: 'Validés',
    },
    content: {
      overview: "Vue d'ensemble", catalog: 'Catalogue', newContent: 'Nouveau contenu',
      categories: 'Catégories', assets: 'Assets', structures: 'Structures', stats: 'Statistiques', audit: 'Audit',
      books: 'Livres', trainings: 'Formations', videos: 'Vidéos', audios: 'Audios',
      distribution: 'Répartition des contenus', library: 'Bibliothèque',
    },
    admin: {
      total: 'Administrateurs', roles: 'Rôles', permissions: 'Permissions', authority: 'Niveaux d’autorité',
      newAdmin: 'Nouvel administrateur', governance: 'Gouvernance',
    },
    marketplace: {
      sellers: 'Vendeurs', applications: 'Candidatures', listings: 'Listings', orders: 'Commandes',
      volume: 'Volume brut', commissions: 'Commissions', favorites: 'Favoris', moderation: 'Modération',
    },
    boutique: {
      products: 'Produits', orders: 'Commandes', categories: 'Catégories', promos: 'Codes promo',
      entitlements: 'Droits d’accès', overview: "Vue d'ensemble",
    },
    community: {
      conversations: 'Conversations', messages: 'Messages', spaces: 'Espaces', calls: 'Appels',
      notifications: 'Notifications', contacts: 'Contacts', activity: 'Activité',
    },
    communication: {
      notifications: 'Notifications', newNotif: 'Nouvelle notification', history: 'Historique',
      stats: 'Statistiques', channels: 'Canaux', sources: 'Sources',
    },
    settings: {
      general: 'Général', platform: 'Plateforme & liens', appearance: 'Apparence',
      locale: 'Langue & formats', prefs: 'Préférences', health: 'Santé écosystème', tech: 'Infos techniques',
      themeNormal: 'Normal', themeLight: 'Clair', themeDark: 'Sombre', themeSystem: 'Système',
      language: 'Langue', density: 'Densité', comfortable: 'Confortable', standard: 'Standard', compact: 'Compact',
      savedLocal: 'Préférence enregistrée localement',
    },
  },
  en: {
    nav: {
      pilotage: 'Command', gestion: 'Management', ecosysteme: 'Ecosystem', systeme: 'System',
      dashboard: 'Dashboard', members: 'Members', finance: 'Finance', rewards: 'Rewards', content: 'Content',
      administrators: 'Administration', marketplace: 'Marketplace', boutique: 'Store',
      community: 'Community', communication: 'Communication', settings: 'Settings',
      configuration: 'Configuration', console: 'System console',
    },
    common: {
      refresh: 'Refresh', save: 'Save', cancel: 'Cancel', confirm: 'Confirm',
      loading: 'Loading...', error: 'Error', empty: 'No data', retry: 'Retry',
      search: 'Search', filters: 'Filters', actions: 'Actions', logout: 'Log out',
      profile: 'Profile', demo: 'Demo data', preparation: 'Preparation',
      close: 'Close', edit: 'Edit', delete: 'Delete', archive: 'Archive',
      active: 'Active', inactive: 'Inactive', operational: 'Operational', unavailable: 'Unavailable',
      total: 'Total', status: 'Status', type: 'Type', date: 'Date', all: 'All',
      overview: 'Overview', details: 'Details', create: 'Create', publish: 'Publish',
      realData: 'Live data', demoData: 'Demo data',
      noData: 'No data available', workerUnavailable: 'Service temporarily unavailable',
      comingSoon: 'Coming soon',
    },
    pages: {
      dashboard: { title: 'Overview', subtitle: 'Global command center for DSI Academy.' },
      members: { title: 'Members', subtitle: 'Analytics and member management.' },
      finance: { title: 'Finance & Transactions', subtitle: 'Financial command center.' },
      rewards: { title: 'Rewards', subtitle: 'Reward codes management.' },
      library: { title: 'Content', subtitle: 'Learning catalog operations.' },
      administrators: { title: 'Administrators', subtitle: 'Access, roles and authority levels.' },
      marketplace: { title: 'Marketplace', subtitle: 'Member-to-member economy control.' },
      boutique: { title: 'DSI Store', subtitle: 'Institutional product operations.' },
      community: { title: 'Community', subtitle: 'Conversations, spaces, calls and activity.' },
      communication: { title: 'Communication', subtitle: 'Notifications and messaging control.' },
      security: { title: 'Control Center', subtitle: 'Platform supervision and maintenance.' },
      settings: { title: 'Settings', subtitle: 'Portal preferences and ecosystem health.' },
    },
    dashboard: {
      members: 'Members', payments: 'Payments', withdrawals: 'Withdrawals', admins: 'Administrators',
      activity: 'Activity', ecosystem: 'Ecosystem', memberStatus: 'Member status',
      financial: 'Financial view',
    },
    members: {
      totalMembers: 'Total members', active: 'Active', pending: 'Pending', inactive: 'Inactive',
      distribution: 'Distribution', evolution: 'Trend', list: 'Member list',
    },
    finance: {
      payments: 'Payments', withdrawals: 'Withdrawal requests', journal: 'Financial journal',
      levels: 'DSI levels', amount: 'Amount', pending: 'Pending', validated: 'Validated',
    },
    content: {
      overview: 'Overview', catalog: 'Catalog', newContent: 'New content',
      categories: 'Categories', assets: 'Assets', structures: 'Structures', stats: 'Statistics', audit: 'Audit',
      books: 'Books', trainings: 'Training', videos: 'Videos', audios: 'Audio',
      distribution: 'Content distribution', library: 'Library',
    },
    admin: {
      total: 'Administrators', roles: 'Roles', permissions: 'Permissions', authority: 'Authority levels',
      newAdmin: 'New administrator', governance: 'Governance',
    },
    marketplace: {
      sellers: 'Sellers', applications: 'Applications', listings: 'Listings', orders: 'Orders',
      volume: 'Gross volume', commissions: 'Commissions', favorites: 'Favorites', moderation: 'Moderation',
    },
    boutique: {
      products: 'Products', orders: 'Orders', categories: 'Categories', promos: 'Promo codes',
      entitlements: 'Entitlements', overview: 'Overview',
    },
    community: {
      conversations: 'Conversations', messages: 'Messages', spaces: 'Spaces', calls: 'Calls',
      notifications: 'Notifications', contacts: 'Contacts', activity: 'Activity',
    },
    communication: {
      notifications: 'Notifications', newNotif: 'New notification', history: 'History',
      stats: 'Statistics', channels: 'Channels', sources: 'Sources',
    },
    settings: {
      general: 'General', platform: 'Platform & links', appearance: 'Appearance',
      locale: 'Language & formats', prefs: 'Preferences', health: 'Ecosystem health', tech: 'Technical info',
      themeNormal: 'Normal', themeLight: 'Light', themeDark: 'Dark', themeSystem: 'System',
      language: 'Language', density: 'Density', comfortable: 'Comfortable', standard: 'Standard', compact: 'Compact',
      savedLocal: 'Preference saved locally',
    },
  },
};

export function t(lang, path) {
  const parts = path.split('.');
  let node = messages[lang] || messages.fr;
  for (const p of parts) {
    if (node && typeof node === 'object' && p in node) node = node[p];
    else {
      node = messages.fr;
      for (const q of parts) {
        if (node && typeof node === 'object' && q in node) node = node[q];
        else return path;
      }
      break;
    }
  }
  return typeof node === 'string' ? node : path;
}
